import request from '@/utils/http-util'
import { baseUrl } from '/env'

export function pageListApi(params) {
    return request({
        url: baseUrl+'/designModel/pageList',
        method: 'get',
        params
    })
}
export function saveOrUpdateApi(data) {
    return request({
        url: baseUrl+'/designModel/saveOrUpdate',
        method: 'post',
        data
    })
}
export function delApi(id) {
    return request({
        url: baseUrl+'/designModel/delete/'+id,
        method: 'delete'
    })
}